import { Icon, IconButton } from '@wegroup/design-system';
import React from 'react';

interface Props {
  onRemove: () => void;
}

const ComparisonBarClose: React.FC<React.PropsWithChildren<Props>> = ({
  onRemove,
}) => {
  return (
    <IconButton
      borderRadius="full"
      variant="dangerSecondary"
      size="6"
      onClick={onRemove}
      icon={<Icon name="GeneralActionsCloseOrRemove" />}
      aria-label="Remove"
    />
  );
};

export default ComparisonBarClose;
